// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Counterparty } from './counterparty';
import { Creditor } from './creditor';
import { SecurityAsset } from './security-asset';
import { SecurityType } from './security-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Security extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  securityId!: number;
  advisedAmountOwing!: number;
  advisedSecurityEstimatedValue!: number;
  advisedSecurityIndependentValue!: number;
  chargeDescription?: string;
  createdBy!: string;
  createdDate!: Date;
  creditorId!: number;
  escrowAccountAccountId?: number;
  grantDate?: Date;
  holderCounterpartyId!: number;
  isNegotiated?: boolean;
  isOverall!: boolean;
  isSpecific!: boolean;
  memo?: string;
  payoutTotal?: number;
  rank!: number;
  rataamountOwing!: number;
  ratasecurityEstimatedValue!: number;
  ratasecurityIndependentValue!: number;
  repaymentTerms?: string;
  securityTypeId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditor!: Creditor;
  holderCounterparty!: Counterparty;
  securityAssets!: SecurityAsset[];
  securityType!: SecurityType;
}

